/** 
* @name: ui-banner
* @Description: 对 el-carousel进行二次封装
* @Author: liulinmei * @Date: 2021-12-15 12:28:46
*/
<template>
  <el-carousel
    :class="{ 'hidden-line': bannerList.length == 1 }"
    v-bind="$attrs"
    v-on="$listeners"
    :arrow="arrow"
    :interval="interval"
    :height="height"
  >
    <el-carousel-item v-for="(item, index) in bannerList" :key="index">
      <el-image
        class="banner-img"
        :src="propKey && propKey.imgSrc ? item[propKey.imgSrc] : item.pic"
        :alt="propKey && propKey.imgPath ? item[propKey.imgPath] : item.url"
        fit="cover"
        @click="
          toLink(propKey && propKey.imgPath ? item[propKey.imgPath] : item.url)
        "
      >
      </el-image>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
  name: 'ui-banner',
  inheritAttrs: false,
  props: {
    arrow: {
      type: String,
      default: 'never',
    },
    interval: {
      type: Number,
      default: 5000,
    },
    height: {
      type: String,
      default: '450px',
    },
    bannerList: {
      type: Array,
      default: () => [],
    },
    propKey: {
      type: Object,
      default: () => ({ imgSrc: 'pic', imgPath: 'url' }),
    },
  },
  methods: {
    toLink(url) {
      url && window.open(url)
    },
  },
}
</script>

<style lang="scss" scoped>
.hidden-line /deep/ .el-carousel__indicators {
  display: none !important;
}
.banner-img {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
</style>
